import { useCallback, useRef } from 'preact/hooks'

export interface UseAnimationEvents {
  ref(el: HTMLElement | null): void
}

export interface AnimationCallbacks {
  onAnimationStart?: () => void
  onAnimationEnd?: () => void
}

export const useAnimationEvents = (callbacks: AnimationCallbacks = {}): UseAnimationEvents => {
  const savedCallbacks = useRef<AnimationCallbacks>()
  savedCallbacks.current = callbacks

  const ref = useRef<HTMLElement>(null)

  const setRef = useCallback((el: HTMLElement | null): void => {
    let counter = 0

    const handleStart = () => {
      const { onAnimationStart } = savedCallbacks.current
      if (0 === counter++) {
        onAnimationStart?.()
      }
    }

    const handleEnd = () => {
      const { onAnimationEnd } = savedCallbacks.current
      if (0 == --counter) {
        onAnimationEnd?.()
      }
    }

    if (ref.current === el) {
      return
    }

    if (ref.current) {
      ref.current.removeEventListener('animationstart', handleStart)
      ref.current.removeEventListener('animationend', handleEnd)
    }

    ref.current = el

    if (ref.current) {
      ref.current.addEventListener('animationstart', handleStart)
      ref.current.addEventListener('animationend', handleEnd)
    }
  }, [])

  return { ref: setRef }
}
